import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';
import api from 'api';

import Grid from './grid/Grid';
import GridElement from './grid/GridElement';
import Calendar from './timetable/Calendar';
import PeriodSelector from './courseSelect/PeriodSelector';
import CourseSelector from './courseSelect/CourseSelector';
import { H1, H3, P } from 'partials/typography';
import { days } from './timetable/timeUnits';
import TimeBlockGrid from './timetable/TimeblockGrid';

import {
    setTimeplanPeriod
} from 'store';

//When selecting course, similar courses from different seasons should be grouped together - for toggling and showing course data in calendar
//Courses should be cleared or at least removed from calendar when toggling seasons.
//Courses should be removed from calendar when entire course is removed from selected list
//Courses should contain course specific data. Data to be stored in redux?

//Can I even handle the collision logic?


export class Timeplan2 extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            period: this.props.cart.items.length === 0 ? "Høst" : (this.props.timeplanPeriod === 'Vår' ? 'Høst' : 'Vår'), //weird hack to make selected period work when re-entering the timeplan
            courses: [],
            selectedCourses: [],
            selectedOptions: [],
            collision: false,
            empty : [],
            emptyReady: false, 
        }
    }
    
    componentDidMount() {
        //Fetching all relevant courses, saving them in courses array as objects with name and course data
        api.courseFetcher.getAll({args: {
            per_page: 1000
        }}).then(r => {
            let courseArr = [];
            let filtered = r.data.filter(course => course.acf.studium !== 'Nettkurs' && course.acf.studium !== 'Forkurs'); 
            let streamingCourses = r.data.filter(course => course.title.rendered.toLowerCase().includes('streaming')); 
            filtered.map(course => {
                if(!streamingCourses.includes(course)){
                    courseArr.push({
                        name: course.title.rendered + ` (${course.acf.period.toLowerCase()})`,
                        value: course
                    })
                }
            })

            streamingCourses.map(course => {
                courseArr.push({
                    name: course.title.rendered + ` (${course.acf.period.toLowerCase()})`,
                    value: course
                })
            })

            this.setState({courses: courseArr})
        })

        // setting selected options
        let options = [];
        let { cart } = this.props; 
        if(cart.items.length > 0){
            cart.items.map(item => {
                if(item.timeplan_option) options.push(item.timeplan_option.id);
            })

            this.setState({ selectedOptions: options }); 
        }

        window.scrollTo(0, 0); 
        
    }

    handleOptionChange = value => {
        //handler for toggling between "høst" and "vår" season.
        this.setState({
            period: value,
            collision: false, 
            empty: []
        })
        this.props.setTimeplanPeriod(value); 
    }

    handleCourses = (courses) => {
        //handling what courses to display in dropdown field
        this.setState({
            selectedCourses: courses, 
            empty: [],
            emptyReady: false
        });
    }

    handleSelectedOptions = arr => {
        //handling which option of course schedule to display in calendar
        this.setState({
            selectedOptions: arr,
            collision: false, 
            empty: [],
            emptyReady: false,
        });
    }

    handleCollision = () => {
        if(!this.state.collision){
            this.setState({ collision: true })
        }
        
    }

    handleEmpty = (index) => {
        if(!this.state.empty.includes(index)){
            this.setState(prevState => ({ 
                empty: [
                    ...prevState.empty, 
                    index
                ], 
                emptyReady: index === this.state.empty.length - 1
            }));
        }
    }
    
    render() {
        const { courses, selectedCourses, selectedOptions, period, collision } = this.state;

        let { data } = this.props;

        return (
            <Wrapper>
                <Top>
                    <H1>{data.title}</H1>
                    <P>{data.description}</P>
                </Top>
                <Grid>
                    <GridElement
                        colStart={{default: 1, m: 1}}
                        colEnd={{default: 8, m: 3}}
                        rowStart={{default: 2, m: 1}}
                    >
                        <CourseSelector 
                            courses={courses}
                            selectedCourses={selectedCourses}
                            period={period}
                            options={selectedOptions}
                            handleOptionChange={this.handleOptionChange}
                            handleSelectedOptions={this.handleSelectedOptions}
                            handleCourses={this.handleCourses}
                        />
                    </GridElement>
                    <GridElement
                        colStart={{default: 0, m: 3}}
                        colEnd={{default: 6, m: 4}}
                        rowStart={{default: 1, m: 1}}
                        justify="center"
                    >
                        <StyledSpan>Periode</StyledSpan>
                        <PeriodSelector 
                            handleOptionChange={this.handleOptionChange}
                            value={this.state.period}
                        />
                    </GridElement>
                    {collision && 
                        <StyledGridElement
                            colStart={{default: 1, m: 5}}
                            colEnd={{default: 8, m: 6}}
                            rowStart={{default: 3, m: 1}}
                            justify="center"
                        >
                            <Collision>
                                <div className="title">Oisann!</div>
                                <P className="text">Det ser ut som at fagene
                                    ikke kan kombineres.
                                    Du kan likevel søke. Bytt
                                    til en annen periode, eller
                                    la en en rådgiver løse det
                                    for deg.
                                </P>
                            </Collision>
                        </StyledGridElement>
                    }
                </Grid>
                <Calendar 
                    courses={selectedCourses}
                    options={selectedOptions}
                    selectedPeriod={this.state.period}
                    handleCollision={this.handleCollision}
                /> 
                
                <MobileCalendar>
                    {(selectedCourses.length > 0 && selectedOptions.length > 0) &&                     
                        days.map((day,idx) => {
                            return (
                                <MobileCalendarBlock className={this.state.empty.includes(idx) && 'hide'} key={idx}>
                                    <H3>{day}</H3>
                                    <div className="wrapper">
                                        <TimeBlockGrid 
                                            courses={selectedCourses}
                                            options={selectedOptions}
                                            index={idx + 1} 
                                            selectedPeriod={period}
                                            handleCollision={() => { this.handleCollision()}}
                                            handleEmpty={() => this.handleEmpty(idx)}    
                                            mobile 
                                        />
                                    </div>
                                </MobileCalendarBlock>
                            )
        
                        })
                    }
                </MobileCalendar> 
            </Wrapper>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return Object.assign({
        timeplanPeriod: state.timeplanPeriod,
        cart: state.cart,
    });
};

const actions = {
    setTimeplanPeriod
}

export default connect(mapStateToProps, actions)(Timeplan2);


const Wrapper = styled.section`
    background: ${css.colors.main};
    color: white;
    padding: 80px 20px 100px; 

    @media(max-width: 768px) {
        padding: 40px 20px 100px;
    }
`

const MobileCalendar = styled.div`
    .hide{
        display: none; 
    }
    @media(min-width: 1000px) {
        display: none; 
    }
`

const MobileCalendarBlock = styled.div`
    h3{
        margin-bottom: 5px; 
    }
`

const StyledSpan = styled.span`
    display: block;
    color: #fff;
    font-family: 'Source Sans Pro', sans-serif; 
    font-weight: 400;
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 25px;

    @media (max-width: 1000px) {
        font-size: 22px;
        margin-bottom: 5px; 
    }
`
const StyledGridElement = styled(GridElement)`
    z-index: 1; 
`

const Collision = styled.div`
    display: flex; 
    flex-direction: column; 
    background-color: #eab4b1; 
    padding: 20px; 
    color: ${css.colors.main};

    .title{
        font-weight: bold; 
        font-size: 24px;
        margin-bottom: 5px; 
    }

    .text{

    }

    &:after{
        content: "";
        position: absolute;
        left: -4px;
        bottom: 0;
        height: calc(100% - 10px);
        border-left: 8px solid white;
        transform: skew(2deg); 
        z-index: -1;
    }

    @media(max-width: 1000px){
        margin-bottom: 20px; 
        .title{
            font-size: 20px;
        }
    }
`

const Top = styled.div`
    text-align: center; 

    h1{
        margin-bottom: 20px; 
    }

    p{
        margin-bottom: 80px;
    }

    @media(max-width: 768px) {
        text-align: left; 

        h1{
            margin-bottom: 10px;
        }

        p{
            margin-bottom: 20px;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/TimePlanTwo.js